import { Link } from 'react-router-dom'
import { useDispatch } from "react-redux";
import { openPopup} from "../../store/popupSlice" 
import Breadcrumb from '../../component/Breadcrumb';

const breadcrumbData = {
  newClass:"center-breadcrumb white-breadcrumb",
  list:[
    {
      page:"Home",
      slug:"/"
    },
    {
      page:"logistic app development",
      slug:""
    },
  ]
}

export default function IndustriesBanner() {
  const dispatch=useDispatch();
  return (
    <>
      <section className="custom-app-banner industries-banner header-gap">
        <div className="custom-banner-img">
          <img src="/assets/home/industries-banner.webp" alt="banner" className='img-responsive'/>
        </div>

        <div className="custom-app-head text-center">
          <Breadcrumb breadcrumbData={breadcrumbData}/>
          <h1 className="heading center-heading"><span>Optimized Fleet Solutions</span> <br />
          for Transport Industry</h1>
          <p className="sub-heading">Advanced GPS Tracking Software Powered by Expertise  <br />
          and Deep Industry Insights.  
          </p>
          <small>21 Days Free Trial | No Credit Card Required</small>
          <Link  onClick={() => dispatch(openPopup())}  className="default-btn animated-btn">
          get started
          </Link> 
        </div>
      </section>
    </>
  )
}
